import hbusApiClient from '../modules/analytics/hbus/hbusApiClient';

const EVENT_NAMES = {
  WEB_VITALS: 'WebVitals',
}

const WebVitalsEvents = {
  sendMetrics({name, value, id, attribution, delta}) {
    let target, eventType;

    switch (name) {
      case 'CLS':
        target = attribution?.largestShiftTarget;
        break;
      case 'LCP':
        target = attribution?.element;
        break;
      default:
        target = attribution?.eventTarget;
        eventType = attribution?.eventType;
        break;
    }

    const eventData = {
      clientType: 'navigation.sendBeacon',
      connectionType: navigator.connection ? navigator.connection.effectiveType : null,
      name: name,
      data: {
        value: value,
        id: id,
        delta: delta,
        target: target,
        eventType: eventType,
      },
      page: window.utagData ? window.utagData.page_type : '',
    }

    hbusApiClient?.sendEventRequest(EVENT_NAMES.WEB_VITALS, eventData);
  },
}

export default WebVitalsEvents;
